import { render, staticRenderFns } from "./ElectionSection.vue?vue&type=template&id=51341643"
import script from "./ElectionSection.vue?vue&type=script&lang=js"
export * from "./ElectionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports